<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-6">
        <label for="email">Email Address <span>*</span></label>
        <input id="email" type="text" placeholder="Email Address" name="email"
               v-model="form.email" v-validate="'required|email|max:100'">
        <span v-if="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <button class="body-8" :disabled="pending || errors.any()">Submit</button>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'ForgotPasswordForm',

    props: ['pending'],

    data: function () {
      return {
        form: {
          email: null
        },
      }
    },

    methods: {
      submit(form) {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$emit('submit', form);
          }
        });
      }
    }
  };
</script>
